const formatDate = (value: string): string => { 
  if (!value) return '';

  const date = new Date(value);
  
  // If it's not a valid UTC date, return as-is
  if (isNaN(date.getTime())) {
    return value;
  }

  const monthString = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  return `${day} ${monthString[month]} ${year}`;
};

export default {
  formatDate
}